import { Location } from "react-router-dom";

import { ERoutes } from "@utils/constants";

import { navTabsDesktop, navTabsMobile } from "./constants";
import { DropdownNavItem } from "./types";

export const isActiveNavItem = (location: Location, routes: ERoutes[]) =>
  routes.some((route) => location.pathname === route);

export const getSubitems = (location: Location, isDesktop: boolean): DropdownNavItem[] => {
  let route = `/${location.pathname.split("/")[1]}`;

  return isDesktop ? navTabsDesktop[route] : navTabsMobile[route];
};

export const isCurrentPage = (location: Location, routes: ERoutes[]) =>
  routes.some((route) => location.pathname.includes(route));
